'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { getAudioStoryService } from '@/contexts/audio-stories/services/AudioStoryService';

export async function generateBlockAudio(
  audioStoryId: string,
  blockId: string,
  overrides?: { voiceId?: string },
): Promise<ActionResult<void>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };
  try {
    await getAudioStoryService().generateBlockAudio(audioStoryId, blockId, familyId, overrides);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    actionErrorLog('generation', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}

export async function generateBatchAudio(audioStoryId: string): Promise<ActionResult<void>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };
  try {
    await getAudioStoryService().generateBatchAudio(audioStoryId, familyId);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    actionErrorLog('generation', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}

export async function assembleAudio(audioStoryId: string): Promise<ActionResult<void>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };
  try {
    await getAudioStoryService().assembleAudio(audioStoryId, familyId);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    actionErrorLog('generation', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}
